import React, { useState, useEffect, useRef } from 'react';
import queryString from 'query-string';
import { v4 as uuidv4 } from 'uuid';
import { withStyles } from '@material-ui/core/styles';
import { fileSelectHandler } from '../../util/fileHandling';
import NoticeDialog from '../../components/DialogModals/NoticeDialog';
import {
  Card,
  Grid,
  CardContent,
  Typography,
  IconButton,
  TextField,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  Link,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import LaunchedOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import Button from '../../components/Button';
import {
  signupPatient,
  creatAssociationReq,
  updatePatient,
  isEmailAvailable,
} from '../../services/api';
import * as authApi from '../../services/api/auth';
import DateSelect from '../../components/DateSelect';
import moment from 'moment';
import * as EmailValidator from 'email-validator';
import './style.css';

function DependentPatientSignUpModal(props) {
  const {
    history,
    location,
    classes: {
      card,
      cardTitle,
      cardContent,
      cardElement,
      signUpButton,
      genderErrLabel,
      birthdateComp,
      subTextField,
      checkBoxes,
      container,
      helperText,
    },
  } = props;
  var date = new Date();
  let minYears = date.setFullYear(date.getFullYear() - 25);

  const [currentUser, setCurrentUser] = useState({});
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState();
  const [lastName, setLastName] = useState('');
  const [gender, setGender] = useState();
  const [birthdate, setBirthdate] = useState();
  const [termsOfUse, setTermsOfUse] = useState(false);
  const [privPolicy, setPrivPolicy] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [signingUpAdult, setSigningUpAdult] = useState(false);
  const [insuranceName, setInsuranceName] = useState();
  const [insuranceId, setInsuranceId] = useState();
  const [birthday, setBirthday] = useState('');
  const [buttonDisable, setButtonDisable] = useState(false);
  const [emailError, setEmailError] = useState(true);
  const [imageFront, setImageFront] = useState([]);
  const [imageBack, setImageBack] = useState([]);
  const [popNotice, setPopNotice] = useState('');
  const myRef = useRef(null);

  useEffect(() => {
    (async () => {
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);
    })();
  }, []);

  const onFieldChange = event => {
    setValidationErrors({ ...validationErrors, [event.target.name]: false });
    switch (event.target.name) {
      case 'firstName':
        setFirstName(event.target.value);
        break;
      case 'lastName':
        setLastName(event.target.value);
        break;
      case 'gender':
        setGender(event.target.value);
        break;
      case 'birthdate':
        const now = new Date().getTime();
        const then = new Date(event.target.value).getTime();
        setSigningUpAdult((now - then) / 1000 / 60 / 60 / 24 / 365 > 18);
        setBirthdate(event.target.value);
        break;
      case 'termsOfUse':
        setTermsOfUse(event.target.checked);
        break;
      case 'email':
        setEmail(event.target.value);
        break;
      case 'insuranceId':
        setInsuranceId(event.target.value);
        break;
      case 'insuranceName':
        setInsuranceName(event.target.value);
        break;
      case 'privPolicy':
        setPrivPolicy(event.target.checked);
        break;
      default:
        throw Error('unknown field changed');
    }
  };

  const inputPicCallBack = fileObject => {
    setImageFront(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImageFront([]);
      }
    });
  };

  const inputPicBackCallBack = fileObject => {
    setImageBack(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImageBack([]);
      }
    });
  };

  const callSetImageFront = event => {
    setImageFront([]);
    fileSelectHandler(
      event.target.files,
      inputPicCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const callSetImageBack = event => {
    setImageBack([]);
    fileSelectHandler(
      event.target.files,
      inputPicBackCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const onSignup = async () => {
    setButtonDisable(true);
    const newPatient = await signupPatient({
      firstName: firstName.replace(/^\s+|\s+$/gm, ''),
      lastName: lastName.replace(/^\s+|\s+$/gm, ''),
      email: signingUpAdult ? email : uuidv4(),
      phone: currentUser.phone,
      birthdate,
      gender,
      password: null,
      attachments: {
        imageFront: imageFront.map(i => i.dataUrl),
        imageBack: imageBack.map(i => i.dataUrl),
      },
      insuranceId,
      insuranceName,
    });
    setButtonDisable(false);
    if (!signingUpAdult) {
      setButtonDisable(true);
      await updatePatient({
        id: newPatient.id,
        email: newPatient.id + '@example.com',
      });
      await creatAssociationReq(newPatient.id, currentUser.patient.id);
      setButtonDisable(false);
    }
    redirect();
  };

  const redirect = () => {
    const queryParams = queryString.parse(location ? location.search : {});
    if (queryParams.redirect === 'back') {
      history.goBack();
    } else if (queryParams.redirect) {
      history.push(queryParams.redirect);
    } else {
      history.push({ pathname: '/sign-up/dependent-patient-conformation' });
    }
  };

  const validate = () => {
    const strPattern = /^[a-zA-Z\s]+$/;
    let valid = true;
    const nextState = {};

    if (signingUpAdult && !email) {
      nextState.email = 'Required';
      valid = false;
    } else if (signingUpAdult && email && !EmailValidator.validate(email)) {
      valid = false;
      nextState.email = 'Please enter a valid email';
    } else if (!emailError) {
      valid = false;
      nextState.email = 'This email is already in use';
    }

    if (!firstName.replace(/^\s+|\s+$/gm, '')) {
      nextState.firstName = 'Required';
      valid = false;
    } else if (!strPattern.test(firstName)) {
      nextState.firstName = 'Can only contain letters';
      valid = false;
    }

    if (!lastName.replace(/^\s+|\s+$/gm, '')) {
      nextState.lastName = 'Required';
      valid = false;
    } else if (!strPattern.test(lastName)) {
      nextState.lastName = 'Can only contain letters';
      valid = false;
    }

    if (!gender) {
      nextState.gender = 'Required';
      valid = false;
    }

    if (!birthdate) {
      nextState.birthdate = 'Please select birthdate';
      valid = false;
    } else if (birthdate === 'Invalid date') {
      valid = false;
      nextState.birthdate = 'Please select valid date';
    }

    if (!termsOfUse) {
      nextState.termsOfUse = 'You need to agree to our terms of use';
      valid = false;
    }

    if (!privPolicy) {
      nextState.privPolicy = 'You need to agree to privacy policy';
      valid = false;
    }

    setValidationErrors(nextState);
    return valid;
  };

  const mimikDatePickEventObj = dateObj => {
    const mimik = {
      target: {
        name: 'birthdate',
        value: dateObj,
      },
    };
    return mimik;
  };

  return (
    <>
      <div className="fullWidthText">
        <Card className={card}>
          <Typography
            variant="h4"
            gutterBottom="true"
            color="textSecondary"
            className={cardTitle}
          >
            Sign Up Dependent
          </Typography>

          <CardContent className={cardContent}>
            <TextField
              label="First Name"
              name="firstName"
              value={firstName}
              variant="outlined"
              onChange={onFieldChange}
              error={validationErrors.firstName}
              helperText={validationErrors.firstName}
              className={cardElement}
            />

            <TextField
              label="Last Name"
              name="lastName"
              value={lastName}
              variant="outlined"
              onChange={onFieldChange}
              error={validationErrors.lastName}
              helperText={validationErrors.lastName}
              className={subTextField}
            />

            <TextField
              fullWidth
              name="insuranceName"
              variant="outlined"
              label="Insurance Name"
              value={insuranceName}
              onChange={onFieldChange}
              className={subTextField}
            />
            <FormHelperText> Optional </FormHelperText>

            <TextField
              fullWidth
              name="insuranceId"
              variant="outlined"
              label="Insurance ID"
              value={insuranceId}
              onChange={onFieldChange}
              className={subTextField}
            />
            <FormHelperText> Optional </FormHelperText>
            <Grid item xs={12}>
              <FormHelperText
                className={helperText}
                style={{ color: '#055C9D', fontSize: '11px' }}
              >
                <WbIncandescentIcon
                  fontSize="small"
                  className="inv-bulb-icon"
                />
                We encourage you to enter your insurance information here, to
                help minimize your wait time at the time of your appointment{' '}
              </FormHelperText>
            </Grid>
            <div className="custom-inline-form">
              <Grid item xs={6} classes={container}>
                <FormLabel component="legend">Upload insurance front</FormLabel>
                <input
                  type="file"
                  ref={myRef}
                  onChange={event => callSetImageFront(event)}
                  className="custom-mt-10"
                />
              </Grid>
              <Grid item xs={6} classes={container}>
                <FormLabel component="legend">Upload insurance back</FormLabel>
                <input
                  type="file"
                  ref={myRef}
                  onChange={event => callSetImageBack(event)}
                  className="custom-mt-10"
                />
              </Grid>
            </div>
            <div>
              <FormControl
                component="fieldset"
                variant="filled"
                className={cardElement}
              >
                <FormLabel component="legend">Gender</FormLabel>
                <RadioGroup
                  row
                  aria-label="Gender"
                  name="gender"
                  value={gender}
                  onChange={onFieldChange}
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Female"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="Male"
                  />
                </RadioGroup>
                {validationErrors.gender && (
                  <FormLabel component="legend" className={genderErrLabel}>
                    {validationErrors.gender}
                  </FormLabel>
                )}
              </FormControl>
            </div>

            <div className={birthdateComp}>
              <FormLabel component="legend">Birthdate</FormLabel>

              <DateSelect
                disableFuture
                fullWidth
                // label="Birthdate"
                format="MM/DD/YYYY"
                maxDate={new Date(minYears)}
                placeholder="MM/DD/YYYY ex.10/02/1981"
                value={new Date(birthdate)}
                error={validationErrors.birthdate}
                helperText={validationErrors.birthdate}
                onChange={date => {
                  setBirthdate(moment.utc(date).format('MM/DD/YYYY'));
                  onFieldChange(mimikDatePickEventObj(date));
                  setValidationErrors({
                    ...validationErrors,
                    birthdate: false,
                  });
                }}
              />
            </div>
            {signingUpAdult && (
              <>
                <p
                  style={{
                    fontSize: '12px',
                  }}
                >
                  If you sign up another adult we need an email to reach them
                </p>
                <TextField
                  label="Email"
                  name="email"
                  variant="outlined"
                  value={email}
                  onChange={onFieldChange}
                  error={validationErrors.email}
                  helperText={validationErrors.email}
                  className={cardElement}
                  onBlur={async () => {
                    const available = await isEmailAvailable(email);
                    setEmailError(available);
                    if (!available) {
                      setValidationErrors({
                        ...validationErrors,
                        email: 'This email is already in use',
                      });
                    }
                  }}
                />
              </>
            )}

            <FormControl
              required
              label="termsOfUse"
              error={!termsOfUse}
              className={checkBoxes}
            >
              <div className="licenseFlex">
                <FormControlLabel
                  control={
                    <Checkbox name="termsOfUse" onChange={onFieldChange} />
                  }
                  label="I have read and accept Qwell's Terms of Use."
                />
                <Link
                  href={
                    process.env.REACT_APP_HOMEPAGE_URL +
                    '/patients-terms-of-use/'
                  }
                  target="_blank"
                  rel="noopener"
                >
                  <IconButton>
                    <LaunchedOutlinedIcon />
                  </IconButton>
                </Link>
              </div>

              <FormHelperText>
                {!termsOfUse ? validationErrors.termsOfUse : ''}
              </FormHelperText>
            </FormControl>

            <FormControl required label="privPolicy" error={!privPolicy}>
              <div className="licenseFlex">
                <FormControlLabel
                  control={
                    <Checkbox name="privPolicy" onChange={onFieldChange} />
                  }
                  label="I have read and accept Qwell's Privacy Policy."
                />
                <Link
                  href={process.env.REACT_APP_HOMEPAGE_URL + '/privacy-policy'}
                  target="_blank"
                  rel="noopener"
                >
                  <IconButton>
                    <LaunchedOutlinedIcon />
                  </IconButton>
                </Link>
              </div>
              <FormHelperText>
                {!privPolicy ? validationErrors.privPolicy : ''}
              </FormHelperText>
            </FormControl>
          </CardContent>
          <Button
            color="primary"
            variant="contained"
            onClick={onSignup}
            onClickValidation={validate}
            className={signUpButton}
            disabled={buttonDisable}
          >
            Sign Up
          </Button>
        </Card>
      </div>
      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={(() => setPopNotice(''))}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}
    </>
  );
}

const styles = theme => ({
  card: {
    width: '480px',
    margin: '50px auto 50px  auto ',
  },
  container: {
    width: '30%',
    backgroundColor: 'white',
    padding: '2rem',
    border: '1px solid rgba(183,210,229,0.8)',
    borderRadius: '8px',
    boxShadow: 'inset 0 -1px 0 0 #7E95A7, 0 1px 4px 0 rgba(44,64,90,0.21)',
    [theme.breakpoints.down('lg')]: {
      width: '45%',
    },
    [theme.breakpoints.down('md')]: {
      width: '65%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
  cardTitle: {
    display: 'inline-block',
    fontWeight: 'bold',
    margin: '30px auto 0px 30px ',
    paddingBottom: '0px',
  },
  cardContent: {
    marginLeft: '40px',
    padding: '0px',
  },
  cardElement: {
    padding: '0px',
    marginTop: '30px',
    width: '300px',
  },
  subTextField: {
    marginTop: '10px',
    width: '300px',
  },
  signUpButton: {
    display: 'block',
    width: '150px',
    margin: '20px auto 20px  auto ',
  },
  genderErrLabel: {
    color: 'red',
    fontSize: '12px',
    marginLeft: '15px',
    marginBottom: '0px',
  },
  birthdateComp: {
    padding: '0px',
    marginTop: '20px',
  },
  checkBoxes: {
    marginTop: '20px',
  },
  helperText: {
    marginLeft: '10px',
  },
});

export default withStyles(styles)(DependentPatientSignUpModal);
